export default "__VITE_ASSET__CdcKW_hf__"